import Glide from '@glidejs/glide';

if (document.querySelector('.glide')) {
  new Glide('.glide', {
    type: 'carousel',
    perView: 1,
    peek: window.innerWidth / 3 - 180,
    autoplay: 5000,
    animationDuration: 500,
  }).mount();
}